// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__2YO75","iconButton":"styles_iconButton__AJaKq"};